var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#184a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "185b",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#185b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0091E",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDD200",
    fillRule: "evenodd",
    d: "M3.143 3.2h15.714v9.6H3.143z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007B5D",
    fillRule: "evenodd",
    d: "M3.143 3.2 11 8l-7.857 4.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BA03",
    fillRule: "evenodd",
    d: "M4.19 7.465h1.048v1.067H4.19z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007B5D",
    fillRule: "evenodd",
    d: "M18.857 3.2 11 8l7.857 4.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3A906",
    fillRule: "evenodd",
    d: "M7.334 1.066H8.38v1.067H7.333zm3.142 0h1.048v1.067h-1.048zm3.143 0h1.048v1.067h-1.048zm-6.285 12.8H8.38v1.067H7.333zm3.142 0h1.048v1.067h-1.048zm3.143 0h1.048v1.067h-1.048z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0091E",
    d: "M11 10.665c1.446 0 2.619-1.194 2.619-2.666 0-1.473-1.173-2.667-2.62-2.667-1.446 0-2.618 1.194-2.618 2.667S9.553 10.665 11 10.665"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDD200",
    fillRule: "evenodd",
    d: "m11 9.332-1.54.825.293-1.747L8.51 7.173l1.721-.253.77-1.588.77 1.59 1.721.252-1.246 1.237.293 1.746",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "184a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagGd = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagGd);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzYyMjlfNzEzNDcpIj4KPG1hc2sgaWQ9Im1hc2swXzYyMjlfNzEzNDciIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyMiIgaGVpZ2h0PSIxNiI+CjxwYXRoIGQ9Ik0xOS45MDQ4IDBIMi4wOTUyNEMwLjkzODA3IDAgMCAwLjk1NTEyNiAwIDIuMTMzMzNWMTMuODY2N0MwIDE1LjA0NDkgMC45MzgwNyAxNiAyLjA5NTI0IDE2SDE5LjkwNDhDMjEuMDYxOSAxNiAyMiAxNS4wNDQ5IDIyIDEzLjg2NjdWMi4xMzMzM0MyMiAwLjk1NTEyNiAyMS4wNjE5IDAgMTkuOTA0OCAwWiIgZmlsbD0id2hpdGUiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzYyMjlfNzEzNDcpIj4KPHBhdGggZD0iTTE5LjkwNDggMEgyLjA5NTI0QzAuOTM4MDcgMCAwIDAuOTU1MTI2IDAgMi4xMzMzM1YxMy44NjY3QzAgMTUuMDQ0OSAwLjkzODA3IDE2IDIuMDk1MjQgMTZIMTkuOTA0OEMyMS4wNjE5IDE2IDIyIDE1LjA0NDkgMjIgMTMuODY2N1YyLjEzMzMzQzIyIDAuOTU1MTI2IDIxLjA2MTkgMCAxOS45MDQ4IDBaIiBmaWxsPSIjRDAwOTFFIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMy4xNDMwNyAzLjE5OTIySDE4Ljg1NzRWMTIuNzk5MkgzLjE0MzA3VjMuMTk5MjJaIiBmaWxsPSIjRkREMjAwIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMy4xNDMwNyAzLjE5OTIyTDExLjAwMDIgNy45OTkyMkwzLjE0MzA3IDEyLjc5OTJWMy4xOTkyMloiIGZpbGw9IiMwMDdCNUQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjE5MDQzIDcuNDY0ODRINS4yMzgwNVY4LjUzMTUxSDQuMTkwNDNWNy40NjQ4NFoiIGZpbGw9IiNGN0JBMDMiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOC44NTcxIDMuMTk5MjJMMTEgNy45OTkyMkwxOC44NTcxIDEyLjc5OTJWMy4xOTkyMloiIGZpbGw9IiMwMDdCNUQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjMzMzUgMS4wNjY0MUg4LjM4MTEyVjIuMTMzMDdINy4zMzM1VjEuMDY2NDFaTTEwLjQ3NjQgMS4wNjY0MUgxMS41MjRWMi4xMzMwN0gxMC40NzY0VjEuMDY2NDFaTTEzLjYxOTIgMS4wNjY0MUgxNC42NjY4VjIuMTMzMDdIMTMuNjE5MlYxLjA2NjQxWk03LjMzMzUgMTMuODY2NEg4LjM4MTEyVjE0LjkzMzFINy4zMzM1VjEzLjg2NjRaTTEwLjQ3NjQgMTMuODY2NEgxMS41MjRWMTQuOTMzMUgxMC40NzY0VjEzLjg2NjRaTTEzLjYxOTIgMTMuODY2NEgxNC42NjY4VjE0LjkzMzFIMTMuNjE5MlYxMy44NjY0WiIgZmlsbD0iI0YzQTkwNiIvPgo8cGF0aCBkPSJNMTAuOTk5OSAxMC42NjU0QzEyLjQ0NjQgMTAuNjY1NCAxMy42MTkgOS40NzE0NiAxMy42MTkgNy45OTg3QzEzLjYxOSA2LjUyNTk0IDEyLjQ0NjQgNS4zMzIwMyAxMC45OTk5IDUuMzMyMDNDOS41NTM0NSA1LjMzMjAzIDguMzgwODYgNi41MjU5NCA4LjM4MDg2IDcuOTk4N0M4LjM4MDg2IDkuNDcxNDYgOS41NTM0NSAxMC42NjU0IDEwLjk5OTkgMTAuNjY1NFoiIGZpbGw9IiNEMDA5MUUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMSA5LjMzMjAzTDkuNDYwMDMgMTAuMTU2Nkw5Ljc1MzM2IDguNDEwNDNMOC41MDg3OSA3LjE3MzFMMTAuMjMgNi45MjAzTDExIDUuMzMyMDNMMTEuNzcgNi45MjEzNkwxMy40OTEzIDcuMTc0MTZMMTIuMjQ0NiA4LjQxMTVMMTIuNTM3OSAxMC4xNTY2IiBmaWxsPSIjRkREMjAwIi8+CjxwYXRoIGQ9Ik0xOS45MDQ5IDAuNTM1MTU2SDIuMDk1MzVDMS4yMjc0OCAwLjUzNTE1NiAwLjUyMzkyNiAxLjI1MTUgMC41MjM5MjYgMi4xMzUxNlYxMy44Njg1QzAuNTIzOTI2IDE0Ljc1MjEgMS4yMjc0OCAxNS40Njg1IDIuMDk1MzUgMTUuNDY4NUgxOS45MDQ5QzIwLjc3MjggMTUuNDY4NSAyMS40NzYzIDE0Ljc1MjEgMjEuNDc2MyAxMy44Njg1VjIuMTM1MTZDMjEuNDc2MyAxLjI1MTUgMjAuNzcyOCAwLjUzNTE1NiAxOS45MDQ5IDAuNTM1MTU2WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLW9wYWNpdHk9IjAuMSIvPgo8L2c+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNjIyOV83MTM0NyI+CjxyZWN0IHdpZHRoPSIyMiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";